import { BrowserRouter as Router, Routes } from "react-router-dom";
import { NeqatyRoutes } from "./routes/NeqatyRoutes";
import { WisdomRoutes } from "./routes/WisdomRoutes";
import { Toaster } from "react-hot-toast";
import { WatomsRoutes } from "./routes/WatomsRoutes";
import { WabysRoutes } from "./routes/WabysRoutes";
import { ParentRoutes } from "./routes/ParentRoutes";
import { StaffRoutes } from "./routes/StaffRoutes";
import { WabysAdminRoutes } from "routes/WabysAdminRoutes";

function App() {
  return (
    <div className="font-sans">
      {/* Global Toaster */}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#0a183d",
            color: "#fff",
            fontSize: "0.9rem",
          },
        }}
      />
      <Router>
        <Routes>
          {/* Wabys's adminstration */}
          {WabysAdminRoutes()}
          {/* Neqaty's system */}
          {NeqatyRoutes()}
          {/* Wabys' system */}
          {WabysRoutes()}
          {/* Wisdom's system */}
          {WisdomRoutes()}
          {/* Watoms' system */}
          {WatomsRoutes()}
          {/* parent's system */}
          {ParentRoutes()}
          {/* staff' system */}
          {StaffRoutes()}
        </Routes>
      </Router>
    </div>
  );
}

export default App;